import React from 'react'
import { profileService } from 'src/services/profile.service'
import styles from './ChatWidget.module.scss';
import { useSelector } from 'react-redux';
import { CHAT_ROOM_STATUS } from './constants';
import { useDispatch } from 'react-redux';
import userChatSlice from 'src/core/redux/userChatSlice/userChatSlice';
import useUserChatAction from 'src/hooks/useUserChatAction';
import clsx from 'clsx';
import { Button } from '@mantine/core';
import { Translate } from 'react-auto-translate';

const BeginChatScreen = () => {

    const { chatRoomStatus, errorMessage } = useSelector(state => state.userChat)
    const dispatch = useDispatch()
    const { initiateChatRequest } = useUserChatAction()

    const handleChatClick = () => {
        initiateChatRequest()
        dispatch(userChatSlice.actions.setChatRoomStatus(CHAT_ROOM_STATUS.REQUEST_INITIATED))
    }

    return (
		<>
			<div
				className={clsx(styles.header, 'd-flex align-items-center p-3')}
			>
				<Translate>
					Chat Support
				</Translate>
			</div>
			<div
				className={clsx(
					styles.content,
					'p-3 d-flex flex-column justify-content-end ',
				)}
			>
				<div>
					<h5>{profileService.settings?.name}</h5>
					<p>
						<Translate>
							We are Here to help you
						</Translate>
					</p>
					<p className="text-danger">
						<Translate>
							{errorMessage}
						</Translate>
					</p>
				</div>
				<Button
					variant="filled"
					onClick={handleChatClick}
					loading={
						chatRoomStatus === CHAT_ROOM_STATUS.REQUEST_INITIATED
					}
					disabled={
						chatRoomStatus === CHAT_ROOM_STATUS.REQUEST_INITIATED
					}
					color="blue"
					size="sm"
					mt="xs"
				>
					<Translate>
						Chat with us now
					</Translate>
				</Button>
			</div>
		</>
	);
}

export default BeginChatScreen